module.exports = __webpack_public_path__ + "img/demo.59e0600d.jpeg";